
const Logo = ({ style }) => {
    return  <div>
                <a href="/"><img style={style} src="/LOGO/ScholarSift-Logo_FullColor.png" alt="Short Logo"/></a>
            </div>
}

export default Logo;